/* Alternix cart drawer line removal: load after cart-notification.js */
(() => {
  const drawer = document.getElementById('cart-notification-clone');
  if (!drawer) return;

  drawer.addEventListener('click', async (event) => {
    const button = event.target.closest('.cart-notification-clone-remove-btn');
    if (!button || !drawer.contains(button) || button.disabled) return;

    event.preventDefault();
    event.stopPropagation();

    const row = button.closest('.cart-notification-product--clone');
    const input = row?.querySelector('.cart-notification-clone-quantity');
    const line = Number(input?.dataset.lineIndex);
    if (!Number.isInteger(line) || line < 1) return;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/change.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({line, quantity: 0})
      });
      if (!response.ok) throw new Error('Unable to remove item');
      const cart = await response.json();

      if (!cart.items.length) {
        window.location.reload();
        return;
      }

      const notification = document.querySelector('cart-notification');
      if (typeof notification?.fetchCartContents !== 'function') {
        window.location.reload();
        return;
      }
      notification.fetchCartContents();
      // Update qualifying delivery immediately; the cart renderer will update totals.
      const freeDelivery = document.querySelector('free-delivery');
      if (typeof freeDelivery?.checkDelivery === 'function') {
        freeDelivery.checkDelivery(cart.total_price / 100);
      }
    } catch (error) {
      console.error('Cart drawer removal failed:', error);
      button.disabled = false;
      button.removeAttribute('aria-busy');
      window.alert('We could not remove this product. Please try again.');
    }
  });
})();
